import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CountUp from "react-countup";
import IndexBanner from "./../components/Element/IndexBanner";
import Jobcategories from "./../components/Element/Jobcategories";
import Featureblog from "./../components/Element/Featureblog";
import Jobsection from "./../components/Element/Jobsection";
import Owltestimonial from "./../components/Element/Owlblog1";
import bnr2 from "./../images/new-updated-images/home/home-testimonial.jpg";
import bnr3 from "./../images/lines.png";
import playStore from "./../images/play-store.png";
import appStore from "./../images/app_store.png";
import IndexBannerComponent from "./../components/Element/IndexBanner";
import composedJobsContainer from "../containers/JobsContainer";
import { saveAs } from "file-saver";
import PopularJobsHome from "../components/Element/PopularJobsHome";

function Homepage(props) {
  const [allJobsRecords, setAllJobsRecords] = useState([]);
  const [jsonArray, setJsonArray] = useState([]);
  const handleDownload = (jsonData) => {
    const file = new Blob([jsonData], { type: "text/json;charset=utf-8" });
    saveAs(file, "hello_world.json");
  };
  useEffect(() => {
    const lenOfData = props.jobsdetails;
    if (lenOfData) {
      setAllJobsRecords(lenOfData);
    }
  }, [props.jobsdetails]);
  // Add title
  if (window.location.pathname == "/") {
    document.getElementById("titleText").innerText =
      "Staffing Connect - Home Page";
  } else {
    document.getElementById("titleText").innerText =
      "Staffing Connect - Home Page Alternate";
  }

  // Plain Html Code Print In Description - Start
  const getPlainHtml = (html) => {
    let tmp = document.createElement("div");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };
  // Plain Html Code Print In Description - End
  // Get Random Numbers - Start
  const generateUniqueNumber = () => {
    // Generate a random number and append timestamp to ensure uniqueness
    const randomNumber = Math.floor(Math.random() * 1000000); // Adjust range as needed
    const timestamp = Date.now(); // Get current timestamp
    return `${randomNumber}${timestamp}`;
  };
  // Get Random Numbers - End

  return (
    <>
      <div className="page-wraper text-left">
        <div className="page-content">
          <IndexBannerComponent callArray={props.jobsdetails} />
          <div className="section-full job-categories content-inner-2 bg-white">
            <div className="container">
              <div className="section-head d-flex head-counter clearfix">
                <div className="mr-auto">
                  <h1 style={{ display: "none" }}>
                    Staffing Connect - Home Page - Explore Home Page Here
                  </h1>
                  <h2 className="m-b1 text-center">
                    Quality Staffing Solutions Tailored to Your Needs
                  </h2>
                  <h6 className="fw3 text-justify">
                    At Staffing Connect, we are committed to providing
                    exceptional services in Education, Home Care, and Social
                    Care sectors, offering both temporary and permanent staffing
                    solutions. Our professional, reliable, and dedicated team
                    works tirelessly to ensure the highest standards are met,
                    helping you find the right people to support your specific
                    needs.
                  </h6>
                </div>
              </div>
            </div>
          </div>

          {/* Popular Jobs - Start */}
          <div className="section-full job-categories bg-white">
            <div className="container">
              <div className="section-head d-flex head-counter clearfix">
                <div className="mr-auto">
                  <h2 className="m-b5">Popular Jobs</h2>
                  <h6 className="fw3">100+ Jobs available for you</h6>
                </div>
                <div className="head-counter-bx">
                  <h2 className="m-b5 counter">
                    <CountUp end={870} duration={5} />
                  </h2>
                  <h6 className="fw3">Jobs Posted</h6>
                </div>
                <div className="head-counter-bx">
                  <h2 className="m-b5 counter">
                    <CountUp end={2800} duration={5} />
                  </h2>
                  <h6 className="fw3">Tasks Posted</h6>
                </div>
                <div className="head-counter-bx">
                  <h2 className="m-b5 counter">
                    <CountUp end={980} duration={5} />
                  </h2>
                  <h6 className="fw3">Freelancers</h6>
                </div>
              </div>
              <PopularJobsHome />
            </div>
          </div>
          {/* Popular Jobs - End */}

          {/* Popular Assignments - Start */}
          <div className="section-full job-categories bg-white pt-5">
            <div className="container">
              <div className="section-head d-flex head-counter clearfix">
                <div className="mr-auto">
                  <h2 className="m-b5">Popular Assignments</h2>
                  <h6 className="fw3">100+ Temporary Jobs available for you</h6>
                </div>
                <div className="head-counter-bx">
                  <h2 className="m-b5 counter">
                    <CountUp end={1800} duration={5} />
                  </h2>
                  <h6 className="fw3">Jobs Posted</h6>
                </div>
                <div className="head-counter-bx">
                  <h2 className="m-b5 counter">
                    <CountUp end={4500} duration={5} />
                  </h2>
                  <h6 className="fw3">Tasks Posted</h6>
                </div>
                <div className="head-counter-bx">
                  <h2 className="m-b5 counter">
                    <CountUp end={1500} duration={5} />
                  </h2>
                  <h6 className="fw3">Freelancers</h6>
                </div>
              </div>
              <Jobcategories />
            </div>
          </div>
          {/* Popular Assignments - End */}
          <Jobsection className="mt--5" />
          {/* Splited Content */}
          <Featureblog />

          <div
            className="section-full p-tb70 overlay-black-dark text-white text-center bg-img-fix "
            style={{ backgroundImage: "url(" + bnr2 + ")" }}
            role="img"
            aria-label="Testimonials Background"
          >
            <div className="container">
              <div className="section-head text-center text-white">
                <h2 className="m-b5">Testimonials</h2>
                <h5 className="fw4">Few words from our Candidates</h5>
              </div>
              <Owltestimonial />
            </div>
          </div>

          <div
            className=" content-inner-2 footerImage footerImageHome"
            style={{
              backgroundImage: "url( " + bnr3 + ")",
              backgroundPosition: "bottom",
              backgroundRepeat: "repeat-x",
            }}
            role="img"
            aria-label="Footer Background"
          ></div>
        </div>
      </div>
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    jobsdetails: state.jobsdetails.jobsdetails,
  };
};
export default composedJobsContainer(Homepage);
